// Subtle Alpha Ape brand watermark for empty states & chart backgrounds.
// Parent must be position:relative + overflow-hidden; content should sit in a relative z-10 layer.
export const ApeWatermark = ({ opacity = 0.05, size = "58%" }) => (
  <img
    src="/alpha-ape.png"
    alt=""
    aria-hidden="true"
    draggable="false"
    className="pointer-events-none select-none absolute inset-0 m-auto object-contain z-0"
    style={{ opacity, maxHeight: size, maxWidth: size }}
  />
);
